import axios from "../../axios-config"

// get mixes library — type: "all" (default) | "mix" | "enhanced"
export const fetchMixedLibrary = async ({ type = "all" } = {}) => {
  const params = { limit: 40 };
  if (type) {
    params.type = type;
  }

  const res = await axios.get(
    `/audio-engineer/v1/mixes-library`,
    { params }
  );

  return res.data || [];
};

//search mixes library
export const searchMixedLibrary = async ({ q, type = "all" }) => {
  const params = { q };
  if (type) {
    params.type = type;
  }

  const res = await axios.get(
    `/audio-engineer/v1/mixes-library/search`,
    { params }
  );

  return res.data?.data || [];
};

//delete a mixed track
export const deleteMixedTrack = async ({ ids }) => {
  const res = await axios.delete(
    `/audio-engineer/v1/mixes-library/${ids}`
  );
  return res.data;
};

//rename a mixed track
export const renameMixedTrack = async (id, body) => {
  const res = await axios.post(
    `/audio-engineer/v1/mixes-library/${id}/rename`, body
  );
  return res.data;
};